<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Pre-Qualification Details</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-12">

        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="templates?.length">
          <mat-label>Copy from ...</mat-label>
          <mat-select placeholder="Copy from ..." name="templateSelector" (selectionChange)="templateChosen()"
            [(ngModel)]="template">
            <mat-option *ngFor="let template of templates" [value]="template">
              {{ template.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Pre-Qualification Name</mat-label>
          <input matInput autocomplete="off" placeholder="Pre-Qualification Name" [(ngModel)]="prequalification.name"
            name="name" type="text" required #name id="name" />
          <mat-error *ngIf="!name.valid">Please enter an Prequalification Name.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Pre-Qualification Description</mat-label>
          <textarea matInput placeholder="Pre-Qualification Description" [(ngModel)]="prequalification.description"
            name="description" #description id="description" rows="5"></textarea>
            <mat-hint>A description that will be presented to the {{ util.getLangTerm('contractors.singular', 'Contractor') }} when they complete their Pre-Qualification.</mat-hint>
        </mat-form-field>

        <div class="full-width mb-3">
          <mat-slide-toggle [(ngModel)]="prequalification.enable_notifications" class="text-wrap"
            name="enable_notifications"
            matTooltip="{{prequalification.enable_notifications ? 'Disable notifications for this Pre-Qualification' : 'Enable notifications for this Pre-Qualification'}}">
            Enable Pre-Qualification Notifications
          </mat-slide-toggle>
        </div>

        <div class="row">
          <div class="col-12">
            <h6>Selectable Pre-Qualification Documents</h6>
          </div>
          <div class="col-12 col-md-6" *ngFor="let item of items; let i = index">
            <mat-checkbox (change)="onToggleItem(item.id)" [checked]="isItemSelected(item.id)">{{ item.name }}
            </mat-checkbox>
          </div>
        </div>

      </div>

    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      id="save"
      type="submit"
      class="save my-2 mx-1">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </mat-dialog-actions>

</form>
